import { appendIf } from "utils";

export const getNumberActions = ({
    showChangeRateNumbersButton,
    showRevokeNumbersButton,
    showMoveToOtherTrunkButton,
    service,
    onOpenChangeRate,
    onOpenRevoke,
    onOpenMove,
    onOpenChangeBillingType,
    onOpenSetIvr,
}) => {
    return [
        ...appendIf(showChangeRateNumbersButton, {
            label: "Change rate",
            handler: onOpenChangeRate,
        }),
        ...appendIf(showRevokeNumbersButton, {
            label: "Revoke numbers",
            handler: onOpenRevoke,
        }),
        ...appendIf(showMoveToOtherTrunkButton, {
            label: "Move to another trunk",
            handler: onOpenMove,
        }),
        ...(service ? [{
            label: "Change billing type",
            handler: onOpenChangeBillingType,
        }, {
            label: "Set IVR",
            handler: onOpenSetIvr,
        }] : []),
    ];
};

export const getPrefixActions = ({
    showModifyPrefixesButton,
    showActivePrefixesButton,
    showDeletePrefixesButton,
    onOpenChangeSupplierRate,
    onActivate,
    onDeactivate,
    onDeletePrefixes,
}) => {
    return [
        ...appendIf(showModifyPrefixesButton, {
            label: "Change rate",
            handler: onOpenChangeSupplierRate,
        }),
        ...appendIf(showActivePrefixesButton, {
            label: "Activate",
            handler: onActivate,
        }),
        ...appendIf(showActivePrefixesButton, {
            label: "Deactivate",
            handler: onDeactivate,
        }),
        ...appendIf(showDeletePrefixesButton, {
            label: "Delete prefixes",
            handler: onDeletePrefixes,
        }),
    ];
};
